export const locale = {
  lang: "it",
  data: {
    MENU: {},
    ALERT: {
      ERROR_UPDATING_EMPLOYEES_TFR_AMOUNT: "Errore nell'aggiornamento dei TFR dei dipendenti.",
      SUCCESS_UPDATING_EMPLOYEES_TFR_AMOUNT: "TFR dei dipendenti aggiornati con successo."
    },
    SELECT_FILE_FOR_EMPLOYEE_COSTS: "Seleziona il file excel con i costi aggiornati e seleziona un mese.",
    SAVED_EMPLOYEE_MONTHLY_COSTS_FOR: "Costi dipendente salvati per",
    CHECK_DATA_AND_SEND: "Controlla ed invia i dati",
    EMPLOYEE_MONTHLY_COSTS: "Costi dipendenti",
    UPDATE_EMPLOYEE_MONTHLY_COSTS: "Aggiorna costi dipendenti",
    ORDINARY_SALARY: "Retribuzione ordinaria lorda",
    REWARDS: "Premi",
    CONTRIBUTIONS: "Contributi",
    HEALTH_CARE: "Ferie e permessi maturati",
    TRANSFERS: "Trasferte",
    EXTRA_CONTRIBUTIONS: "Contributi per straordinari",
    EXTRA_SALARY: "Retribuzione per straordinari",
    TFR_SLICE: "Quota TFR",
    DETAIL_EMPLOYEE_COSTS: "Dettaglio costi dipendente",
    LIST_EMPLOYEE_MONTHLY_COSTS: "Lista costi mensili dei dipendenti",
    UPDATE_EMPLOYEE_CONTRACT_COSTS: "Aggiorna contratti dipendenti",
    EMPLOYEES_NOT_FOUND: "Dipendenti non trovati",
    UPLOADED_DATA_SUMMARY: "Riepilogo dati caricati",
    UPLOAD_EMPLOYEE_DATA: "Carica file contratti dipendenti",
    CALCULATE_COSTS: "Calcolo costi",
    SALARY_GROSS_MONTH_12: "Lordo mensile (no 13ª)",
    ERRORS_UPDATING_COSTS: "Errore nell'aggiornamento dei costi",
    ERRORS_UPDATING_CONTRACTS: "Errore/i nell'aggiornamento dei contratti",
    CALCULATING_EMPLOYEES_CONTRACTS_COSTS: "Calcolo costi contratti dipendenti",
    UPDATING_EMPLOYEES_CONTRACTS_COSTS: "Aggiorno costi contratti dipendenti",
    EMPLOYEE_TFR_AMOUNT: "Totale TFR dipendenti",
    UPDATE_EMPLOYEE_TFR_AMOUNT: "Aggiorna totali TFR dei dipendenti",
    SELECT_FILE_FOR_IMPORT_EMPLOYEES_TFR_AMOUNT: "Seleziona un file excel per importare i TFR dei dipendenti",
    SAVED_TFR_AMOUNTS: "TFR dei dipendenti attualmente salvati",
    PLEASE_VERIFY_DATA_BEFORE_IMPORT: "Verifica i dati prima di fare l'import",
    ERROR_UPDATING_TFR_FOR_THESE_EMPLOYEES: "Errore nell'aggiornamento dei TFR per alcuni dipendenti.",
  },
};
